// import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute } from '@angular/router';
import { EventsService, StorageService, UtilService, VariablesService } from 'src/app/shared/services';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-saf-review',
  standalone: true,
  templateUrl: './saf-review.component.html',
  styleUrls: ['./saf-review.component.scss'],
  imports: [MatIconModule],
})
export class SafReviewComponent {
  campaignId:any;

  constructor(
    private vars: VariablesService,
    private util: UtilService,
    private activatedRoute: ActivatedRoute,
    private storageService: StorageService,
    private eventsService: EventsService,
    // private location: Location
  ) { }

  ngOnInit() {
    this.vars.mainLayoutConfig.next({
      showCurrency: false,
      showFooter: false,
      showFooterSEO: false,
      showDownloadApp: false,
      showHeader: true,
      headerTopSticky: true,
      showMenus: false,
      showLanguage: false,
      showProfile: true,
      showSearch: false,
      showHospFooterSeo: false,
      showSecure: false,
      logoNavigate: true
    })
    this.vars.pageName = 'non_medical_review_page';
    this.campaignId = this.activatedRoute.snapshot.queryParams?.campaign_id;
    this.pageViewEvents();
  }

  pageViewEvents(){
    // const origin = this.util.domain_details.domain_url;
    const payload = {
      // 'ab_testname': `saf_AB`,
      // 'ab_value': true,
      // 'page_url': `${origin}/new/campaign_created`,
      'event_type': 'campaign',
      // 'page_name': 'campaign_review_page',
      'event_type_id': this.campaignId,
      'info_3': this.storageService.get('safLanguage'),
      'eventName': 'pageView',
    };
    this.eventsService.onLoadSystemEvent(payload);
  }

  goToDashboard() {
    const url = environment.manage_domain + '/manage/' + this.campaignId + '/dashboard';
    this.util.nativeNavigation(url);
  }

  // goBack() {
  //   this.location.back();
  // }
}
